import React, { PureComponent, ReactNode } from "react";
import { ALL_INSTRUMENT_TYPES, INSTR_TYPE_NAMES, InstrumentType } from "./InstrumentTypes.model";
import "./InstrumentTypeDropdown.css";

interface Props {
  instrumentType: InstrumentType;
  onChange: (it: InstrumentType) => void;
}
interface State {}

class InstrumentTypeDropdown extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      selectedType: ALL_INSTRUMENT_TYPES[0],
    };
  }

  handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    this.props.onChange(e.target.value as InstrumentType);
  };

  render(): ReactNode {
    const { instrumentType } = this.props;
    return (
      <span className="instrument-type">
        {/* <label htmlFor="instr-type">Instrument: </label> */}
        <select name="instr-type" id="instr-type" value={instrumentType} onChange={this.handleChange}>
          {ALL_INSTRUMENT_TYPES.map((it) => {
            return (
              <option key={it} value={it}>
                {INSTR_TYPE_NAMES[it]}
              </option>
            );
          })}
        </select>
      </span>
    );
  }
}

export default InstrumentTypeDropdown;
